import { Skeleton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import CustomizedTables from "./Table";
import { useAppSelector } from "app/hooks";
import { selectIsAssignmentUsageLoading } from "features/Reports";

interface IProps {
  data: (string | number)[][];
}
const customStyles = {
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    padding: "20px",
    "@media print": {
      width: "100%",
      breakInside: "auto",
      colorAdjust: "exact",
      pageBreakBefore: "always",
      pageBreakAfter: "always",
    },
  },
  header: {
    padding: "10px 30px",
    fontWeight: "bold",
    fontSize: "14px",
    "@media print": {
      breakInside: "avoid",
      pageBreakBefore: "avoid",
      pageBreakAfter: "avoid",
    },
  },
};
const AssignmentData = ({ data }: IProps) => {
  const isAssignmentUsageLoading = useAppSelector(
    selectIsAssignmentUsageLoading
  );
  const { t } = useTranslation();
  const headerData = [
    t("teacherName"),
    t("lessonsAssigned"),
    t("lessonsCompleted"),
    t("freeplayAssigned"),
    t("freeplayCompleted"),
  ];

  return (
    <Typography component="div" sx={customStyles.root}>
      {isAssignmentUsageLoading ? (
        <Skeleton variant="rectangular" height={250} />
      ) : data.length ? (
        <>
          <Typography component="h1" sx={customStyles.header}>
            {t("Assignment Data")}
          </Typography>
          <CustomizedTables headerData={headerData} rowsData={data} />
        </>
      ) : null}
    </Typography>
  );
};

export default AssignmentData;
